// import React from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from '@mui/material';
// import colors from '../theme/Colors';

// const InventoryTable = ({ header,totalPages,page,handlePageChange,handleChangeRowsPerPage,rowsPerPage,inventory, headerData, setEditData, handleDelete }) => {


//   return (
//     <>
//       <TableContainer component={Paper} sx={{ boxShadow: 'none', marginBottom: 2 }}>
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold',
//                   width: '100px'
//                 }}
//               >
//                 PARTY
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   width: '100px'
//                 }}
//               >
//                 {headerData.party}
//               </TableCell>
//               <TableCell
//                 colSpan={6}
//                 align="center"
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Available Stock
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold',
//                   width: '100px'
//                 }}
//               >
//                 Quantity in Container
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   width: '100px'
//                 }}
//               >
//                 {header?.total_qt_in_container}
//               </TableCell>
//             </TableRow>
//             <TableRow>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold'
//                 }}
//               >
//                 ITEM
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5'
//                 }}
//               >
//                 {headerData.item}
//               </TableCell>
//               <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Quantity in Hand
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5'
//                 }}
//               >
//                 {header?.total_qt_in_hand}
//               </TableCell>
//             </TableRow>
//             <TableRow>
//             <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold'
//                 }}
//               >
//                 P-STYLE/Style
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5'
//                 }}
//               >
//                 {headerData.pStyle}
//               </TableCell>
//               <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Total Quantity
//               </TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5'
//                 }}
//               >
//                 {header?.total_qt}
//               </TableCell>
//             </TableRow>

//           </TableHead>
//         </Table>
//       </TableContainer>

//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell
//                 colSpan={11}
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   textAlign: 'center'
//                 }}
//               ></TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   fontWeight: 'bold',
//                   textAlign: 'center'
//                 }}
//               >DETAILS</TableCell>
//             </TableRow>
//             <TableRow>
//               <TableCell
//                 colSpan={10}
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   textAlign: 'center'
//                 }}
//               ></TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   fontWeight: 'bold',
//                   textAlign: 'center'
//                 }}
//               >IN HAND</TableCell>
//               <TableCell
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: '#f5f5f5',
//                   fontWeight: 'bold',
//                   textAlign: 'center'
//                 }}
//               >CONTAINER</TableCell>
//             </TableRow>
//             <TableRow>
//               {['Color', 'S', 'M', 'L', 'XL', '2XL', 'MIX', 'Total', 'Total', 'Total'].map((header, index) => (
//                 <TableCell
//                   key={index}
//                   sx={{
//                     border: '1px solid black',
//                     padding: '8px',
//                     backgroundColor: colors.primary,
//                     fontWeight: 'bold',
//                     textAlign: 'center'
//                   }}
//                   colSpan={index < 7 ? 1 : 2}
//                 >
//                   {header}
//                 </TableCell>

//               ))}
//             </TableRow>


//           </TableHead>
//           <TableBody>
//             {inventory?.map((item) => {
//               // const totalInHand = item.totalQuantityInHand || 0;
//               // const totalInContainer = item.totalQuantity - totalInHand;
//               // const grandTotal = item.totalQuantity;
//               const totalInHand = item.sizes?.reduce(
//                 (acc, size) => acc + (size.quantity_in_hand || 0),
//                 0
//               );

//               const totalInContainer = item.sizes?.reduce(
//                 (acc, size) => acc + (size.quantity_in_container || 0),
//                 0
//               );

//               const grandTotal = totalInHand + totalInContainer;

//               return (
//                 <TableRow key={item._id}>
//                   <TableCell
//                     sx={{
//                       border: '1px solid black',
//                       padding: '8px',
//                       textAlign: 'center',
//                     }}
//                   >
//                     {item.color}
//                   </TableCell>

//                   {/* Size columns */}
//                   {['S', 'M', 'L', 'XL', '2XL', 'MIX'].map((size) => {
//                     const sizeData = item.sizes.find(
//                       (s) => s.size?.toLowerCase() === size.toLowerCase()
//                     );
//                     return (
//                       <TableCell
//                         key={size}
//                         sx={{
//                           border: '1px solid black',
//                           padding: '8px',
//                           textAlign: 'center',
//                         }}
//                       >
//                         {sizeData ? sizeData.quantity_in_hand : '0'}
//                       </TableCell>
//                     );
//                   })}

//                   {/* Grand total */}
//                   <TableCell
//                     sx={{
//                       border: '1px solid black',
//                       padding: '8px',
//                       textAlign: 'center',
//                     }}
//                     colSpan={2}
//                   >
//                     {grandTotal}
//                   </TableCell>

//                   {/* Total in hand */}
//                   <TableCell
//                     sx={{
//                       border: '1px solid black',
//                       padding: '8px',
//                       textAlign: 'center',
//                     }}
//                     colSpan={2}
//                   >
//                     {totalInHand}
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       border: '1px solid black',
//                       padding: '8px',
//                       textAlign: 'center',
//                     }}
//                     colSpan={2}
//                   >
//                     {totalInContainer}
//                   </TableCell>

//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// };

// export default InventoryTable; 
// import React from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
// } from '@mui/material';
// import colors from '../theme/Colors';

// const InventoryTable = ({
//   header,
//   totalPages,
//   page,
//   handlePageChange,
//   handleChangeRowsPerPage,
//   rowsPerPage,
//   inventory,
//   headerData,
//   setEditData,
//   handleDelete,
// }) => {
//   return (
//     <>
//       {/* Header Info Table */}
//       <TableContainer component={Paper} sx={{ boxShadow: 'none', marginBottom: 2 }}>
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', width: '100px' }}>
//                 PARTY
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', width: '100px' }}>
//                 {headerData.party}
//               </TableCell>
//               <TableCell colSpan={6} align="center" sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
//                 Available Stock
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', width: '100px' }}>
//                 Quantity in Container
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', width: '100px' }}>
//                 {header?.total_qt_in_container}
//               </TableCell>
//             </TableRow>
//             <TableRow>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold' }}>
//                 ITEM
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5' }}>
//                 {headerData.item}
//               </TableCell>
//               <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold' }}>
//                 Quantity in Hand
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5' }}>
//                 {header?.total_qt_in_hand}
//               </TableCell>
//             </TableRow>
//             <TableRow>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold' }}>
//                 P-STYLE/Style
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5' }}>
//                 {headerData.pStyle}
//               </TableCell>
//               <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold' }}>
//                 Total Quantity
//               </TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5' }}>
//                 {header?.total_qt}
//               </TableCell>
//             </TableRow>
//           </TableHead>
//         </Table>
//       </TableContainer>

//       {/* Main Inventory Table */}
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             {/* First row of header */}
//             <TableRow>
//               <TableCell
//                 rowSpan={2}
//                 sx={{
//                   border: '1px solid black',
//                   padding: '8px',
//                   backgroundColor: colors.primary,
//                   fontWeight: 'bold',
//                   textAlign: 'center',
//                 }}
//               >
//                 Color
//               </TableCell>

//               {/* Grouped Headers */}
//               <TableCell colSpan={2} sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center' }}>
//                 Small
//               </TableCell>
//               <TableCell colSpan={2} sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center' }}>
//                 Medium
//               </TableCell>
//               <TableCell colSpan={2} sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center' }}>
//                 Large
//               </TableCell>

//               {/* Other sizes remain single */}
//               {['XL', '2XL', 'MIX'].map((size) => (
//                 <TableCell
//                   key={size}
//                   rowSpan={2}
//                   sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center' }}
//                 >
//                   {size}
//                 </TableCell>
//               ))}

//               {/* Totals */}
//               {['Total', 'In Hand', 'Container'].map((label) => (
//                 <TableCell
//                   key={label}
//                   rowSpan={2}
//                   sx={{ border: '1px solid black', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center' }}
//                 >
//                   {label}
//                 </TableCell>
//               ))}
//             </TableRow>

//             {/* Second row of header (sub columns) */}
//             <TableRow>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>6M</TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>2Y</TableCell>

//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>12M</TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>4Y</TableCell>

//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>18M</TableCell>
//               <TableCell sx={{ border: '1px solid black', backgroundColor: '#f5f5f5', textAlign: 'center' }}>6Y</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {inventory?.map((item) => {
//               const totalInHand = item.sizes?.reduce((acc, size) => acc + (size.quantity_in_hand || 0), 0);
//               const totalInContainer = item.sizes?.reduce((acc, size) => acc + (size.quantity_in_container || 0), 0);
//               const grandTotal = totalInHand + totalInContainer;

//               return (
//                 <TableRow key={item._id}>
//                   <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>{item.color}</TableCell>

//                   {/* Small (merged col) */}
//                   <TableCell colSpan={2} sx={{ border: '1px solid black', textAlign: 'center' }}>
//                     {item.sizes.find((s) => s.size === 'S')?.quantity_in_hand || 0}
//                   </TableCell>

//                   {/* Medium (merged col) */}
//                   <TableCell colSpan={2} sx={{ border: '1px solid black', textAlign: 'center' }}>
//                     {item.sizes.find((s) => s.size === 'M')?.quantity_in_hand || 0}
//                   </TableCell>

//                   {/* Large (merged col) */}
//                   <TableCell colSpan={2} sx={{ border: '1px solid black', textAlign: 'center' }}>
//                     {item.sizes.find((s) => s.size === 'L')?.quantity_in_hand || 0}
//                   </TableCell>

//                   {/* Other single sizes */}
//                   {['XL', '2XL', 'MIX'].map((size) => (
//                     <TableCell key={size} sx={{ border: '1px solid black', textAlign: 'center' }}>
//                       {item.sizes.find((s) => s.size === size)?.quantity_in_hand || 0}
//                     </TableCell>
//                   ))}

//                   {/* Totals */}
//                   <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>{grandTotal}</TableCell>
//                   <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>{totalInHand}</TableCell>
//                   <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>{totalInContainer}</TableCell>
//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// };

// export default InventoryTable;

import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import colors from '../theme/Colors';

/**
 * InventoryTable
 *
 * - groups: grouped sizes (S, M, L) with their sub-keys (actual size keys found in item.sizes)
 * - otherSizes: single columns that remain as-is
 *
 * Notes:
 * - The header is two rows: top row shows "Small/Medium/Large" with colSpan=2; second row shows the two sublabels (derived from subKeys).
 * - In the body we render a single cell for each group (colSpan matches the group's subKey length), showing the group's value.
 * - Adjust MAX_TABLE_HEIGHT to control the visible table height and vertical scroll.
 */

const MAX_TABLE_HEIGHT = 480; // px — change this to your preferred fixed table height
const leftSizes = ['XS'];
const groups = [
  { key: 'S', label: 'Small', subKeys: ['S6M', 'S2Y'] },   // subKeys are the actual keys in item.sizes
  { key: 'M', label: 'Medium', subKeys: ['M12M', 'M4Y'] },
  { key: 'L', label: 'Large', subKeys: ['L18M', 'L6X'] },
];

// the other single-size columns that remain single
const otherSizes = ['XL', '2XL', '3XL', 'MIX'];

const InventoryTable = ({
  header,
  inventory = [],
  headerData = {},
  /* you can pass setEditData, handleDelete, etc if needed elsewhere */
}) => {
  // total number of size-columns in header (counting sub columns)
  const sizesColumnsCount = groups.reduce((acc, g) => acc + g.subKeys.length, 0) + otherSizes.length;

  // helper to display subheader label from subKey (e.g. 'S6M' -> '6M', 'M12M' -> '12M')
  const subLabelFromKey = (subKey) => subKey.replace(/^[A-Za-z]+/, '');

  // helper to get the merged value for a group in the body:
  // Prefer an entry exactly matching group.key (e.g. 'S'), otherwise sum its subKeys
  const getGroupValue = (item, group) => {
    if (!item?.sizes) return 0;
    const mainEntry = item.sizes.find(s => (s.size === group.key));
    if (mainEntry && (mainEntry.quantity_in_hand !== undefined)) {
      return mainEntry.quantity_in_hand;
    }
    // sum subKeys
    return group.subKeys.reduce((sum, sk) => {
      const e = item.sizes.find(s => s.size === sk);
      return sum + (e?.quantity_in_hand || 0);
    }, 0);
  };

  const getSingleSizeValue = (item, sizeKey) =>
    item?.sizes?.find(s => s.size === sizeKey)?.quantity_in_hand || 0;

  return (
    <>
      {/* ===== Top Info Section (keeps previous look but uses dynamic colSpan) ===== */}
      <TableContainer component={Paper} sx={{ boxShadow: 'none', marginBottom: 2 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: colors.primary,
                  fontWeight: 'bold',
                  width: '120px',
                }}
              >
                PARTY
              </TableCell>

              <TableCell
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: '#f5f5f5',
                  width: '120px',
                }}
              >
                {headerData.party}
              </TableCell>

              {/* Available Stock spans all size-columns */}
              <TableCell
                colSpan={sizesColumnsCount}
                align="center"
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: '#f5f5f5',
                  fontWeight: 'bold',
                }}
              >
                Available Stock
              </TableCell>

              {/* <TableCell
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: colors.primary,
                  fontWeight: 'bold',
                  width: '140px',
                }}
              >
                Quantity in Container
              </TableCell>

              <TableCell
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: '#f5f5f5',
                  width: '140px',
                }}
              >
                {header?.total_qt_in_container}
              </TableCell> */}
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold' }}>
                Quantity in Hand
              </TableCell>
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5' }}>
                {header?.total_qt_in_hand}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: colors.primary,
                  fontWeight: 'bold',
                }}
              >
                ITEM
              </TableCell>
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5' }}>
                {headerData.item}
              </TableCell>

              {/* placeholder area matching sizes columns */}
              <TableCell colSpan={sizesColumnsCount} sx={{ backgroundColor: '#f5f5f5', border: 'none' }} />
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold' }}>
                Total Quantity
              </TableCell>
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5' }}>
                {header?.total_qt}
              </TableCell>
              
            </TableRow>

            <TableRow>
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold' }}>
                P-STYLE/Style
              </TableCell>
              <TableCell sx={{ border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5' }}>
                {headerData.pStyle}
              </TableCell>

              <TableCell colSpan={sizesColumnsCount} sx={{ backgroundColor: '#f5f5f5', border: 'none' }} />

             
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>

      {/* ===== Main Inventory Table: fixed height + vertical scroll + sticky header ===== */}
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: `${MAX_TABLE_HEIGHT}px`,
          overflowY: 'auto',
          overflowX: 'auto', // allow horizontal scroll if too wide
        }}
      >
        <Table stickyHeader size="small" sx={{ minWidth: 1100 /* increase if you add many columns */ }}>
          <TableHead>
            {/* First row: subkeys */}
            <TableRow>
              <TableCell
                rowSpan={2}
                sx={{
                  border: '1px solid black',
                  padding: '8px',
                  backgroundColor: colors.primary,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  top: 0,
                }}
              >
                Color
              </TableCell>
              {leftSizes.map(sz => (
      <TableCell
        key={sz}
        rowSpan={2}
        sx={{
          border: '1px solid black',
          padding: '8px',
          backgroundColor: colors.primary,
          fontWeight: 'bold',
          textAlign: 'center',
          top: 0,
        }}
      >
        {sz}
      </TableCell>
    ))}
              {/* Subkeys go first */}
              {groups.map(g =>
                g.subKeys.map(subKey => (
                  <TableCell
                    key={subKey}
                    sx={{
                      border: '1px solid black',
                      padding: '8px',
                      backgroundColor: colors.primary,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      top: 0,
                    }}
                  >
                    {subLabelFromKey(subKey)}
                  </TableCell>
                ))
              )}

              {/* Other single sizes (rowSpan=2 because they don’t split) */}
              {otherSizes.map(sz => (
                <TableCell
                  key={sz}
                  rowSpan={2}
                  sx={{
                    border: '1px solid black',
                    padding: '8px',
                    backgroundColor: colors.primary,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    top: 0,
                  }}
                >
                  {sz}
                </TableCell>
              ))}

              {/* Totals (rowSpan=2 as well) */}
              <TableCell rowSpan={2} sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center', top: 0 }}>
                Total
              </TableCell>
              <TableCell rowSpan={2} sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center', top: 0 }}>
                In Hand
              </TableCell>
              {/* <TableCell rowSpan={2} sx={{ border: '1px solid black', padding: '8px', backgroundColor: colors.primary, fontWeight: 'bold', textAlign: 'center', top: 0 }}>
                Container
              </TableCell> */}
            </TableRow>

            {/* Second row: group labels */}
            <TableRow>
              {groups.map(g => (
                <TableCell
                  key={g.key}
                  colSpan={g.subKeys.length}
                  sx={{
                    border: '1px solid black',
                    padding: '8px',
                    backgroundColor: colors.primary,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {g.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>


          <TableBody>
            {inventory?.map((item) => {
              const totalInHand = item.sizes?.reduce((acc, size) => acc + (size.quantity_in_hand || 0), 0);
              const totalInContainer = item.sizes?.reduce((acc, size) => acc + (size.quantity_in_container || 0), 0);
              const grandTotal = totalInHand + totalInContainer;

              return (
                <TableRow key={item._id ?? Math.random()}>
                  {/* Color */}
                  <TableCell sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                    {item.color}
                  </TableCell>
                  {leftSizes.map(sz => (
  <TableCell key={sz} sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
    {getSingleSizeValue(item, sz)}
  </TableCell>
))}
                  {/* Group cells (merged columns) */}
                  {groups.map(g => (
                    <TableCell
                      key={g.key}
                      colSpan={g.subKeys.length}
                      sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}
                    >
                      {getGroupValue(item, g)}
                    </TableCell>
                  ))}

                  {/* Other single sizes */}
                  {otherSizes.map(sz => (
                    <TableCell key={sz} sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                      {getSingleSizeValue(item, sz)}
                    </TableCell>
                  ))}

                  {/* Totals */}
                  <TableCell sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                    {grandTotal}
                  </TableCell>
                  <TableCell sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                    {totalInHand}
                  </TableCell>
                  {/* <TableCell sx={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                    {totalInContainer}
                  </TableCell> */}
                </TableRow>
              );
            })}

            {/* optional: show a "no data" row */}
            {(!inventory || inventory.length === 0) && (
              <TableRow>
                <TableCell colSpan={1 + groups.reduce((s, g) => s + g.subKeys.length, 0) + otherSizes.length + 3} sx={{ textAlign: 'center', padding: 4 }}>
                  No inventory found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default InventoryTable;
